export type Locales = {
  MESSAGES: {
    NOT_ENTERED: {
      requestType: string;
      nameLast: string;
      nameFirst: string;
      kana: string;
      phone: string;
      email: string;
      body: string;
    };
    INCORRECT_FORMAT: {
      kana: string;
      phone: string;
      email: string;
    };
    MUST_BE_TRUE: {
      privacy: string;
    };
    MAX_LENGTH: {
      name: string;
      kana: string;
      phone: string;
      email: string;
      body: string;
    };
  };
};

type LocalesType = {
  ja: Locales;
  en: Locales;
};

export const locales: LocalesType = {
  ja: {
    /**
     * @doc メッセージ（日本語）
     */
    MESSAGES: {
      NOT_ENTERED: {
        // requestType: 'お問い合わせ種別を選択してください',
        // nameLast: 'お名前（姓）を入力してください',
        // nameFirst: 'お名前（名）を入力してください',
        // kana: 'フリガナを入力してください',
        // phone: 'お電話番号を入力してください',
        // email: 'メールアドレスを入力してください',
        // body: 'お問い合わせ内容を入力してください',
        requestType: '必須選択です',
        nameLast: '必須入力です',
        nameFirst: '必須入力です',
        kana: '必須入力です',
        phone: '必須入力です',
        email: '必須入力です',
        body: '必須入力です',
      },
      INCORRECT_FORMAT: {
        kana: 'ひらがなで入力してください',
        phone: 'お電話番号の形式が正しくありません',
        email: 'メールアドレスの形式が正しくありません',
      },
      MUST_BE_TRUE: {
        privacy: '必須選択です',
      },
      MAX_LENGTH: {
        name: 'お名前は、%{n}字以内で入力してください',
        kana: 'ひらがなは、%{n}字以内で入力してください',
        phone: 'お電話番号は、%{n}字以内で入力してください',
        email: 'メールアドレスは、%{n}字以内で入力してください',
        body: 'お問い合わせ内容は、%{n}字以内で入力してください',
      },
    },
  },
  en: {
    /**
     * @doc Messages (English)
     */
    MESSAGES: {
      NOT_ENTERED: {
        requestType: 'Selection required',
        nameLast: 'Required field',
        nameFirst: 'Required field',
        kana: 'Required field',
        phone: 'Required field',
        email: 'Required field',
        body: 'Required field',
      },
      INCORRECT_FORMAT: {
        kana: 'Please enter using hiragana',
        phone: 'Phone number format is incorrect',
        email: 'Email address format is incorrect',
      },
      MUST_BE_TRUE: {
        privacy: 'Selection required',
      },
      MAX_LENGTH: {
        name: 'Please enter your name within %{n} characters',
        kana: 'Please enter hiragana within %{n} characters',
        phone: 'Please enter your phone number within %{n} characters',
        email: 'Please enter your email address within %{n} characters',
        body: 'Please enter your inquiry within %{n} characters',
      },
    },
  },
};
